// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import SelectInput from './SelectInput'
import styled, { type StyledComponent } from 'styled-components'
import type { OptionType } from '../../types'

const Row: StyledComponent<Object, any, any> = styled.div`
  padding-bottom: 14px;
  white-space: nowrap;
`
const RowHeader: StyledComponent<Object, any, any> = styled.div`
  font-weight: bold;
  font-size: 16px;
  padding: 10px 0;
  color: #666;
`
const SelectInputWrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
`

type Props = {|
  vkOptions: Array<OptionType>,
  tmOptions: Array<OptionType>,
  fbOptions: Array<OptionType>,
  vkValue: ?string,
  tmValue: ?string,
  fbValue: ?string,
  onVkChange: Function,
  onTmChange: Function,
  onFbChange: Function,
  hideVk?: boolean,
  hideTm?: boolean,
  hideFb?: boolean,
  vkErrors?: Array<string>,
  tmErrors?: Array<string>,
  fbErrors?: Array<string>
|}

const t = {
  link_buttons_header: 'Настройка кнопок',
  vk_link_button_header: 'ВКонтакте',
  fb_link_button_header: 'Facebook',
  tm_link_button_header: 'myTarget'
}

export default class LinkButtons extends Component<Props> {
  render() {
    return (
      this.isShown() && (
        <Row>
          <RowHeader>{t.link_buttons_header}</RowHeader>
          <SelectInputWrapper>
            {!this.props.hideVk && (
              <SelectInput
                className="t-VkLinkButtonInput__select"
                header={t.vk_link_button_header}
                errors={this.props.vkErrors}
                value={this.props.vkValue || _.first(this.props.vkOptions).id}
                options={this.props.vkOptions}
                onChange={this.props.onVkChange}
              />
            )}
            {!this.props.hideTm && (
              <SelectInput
                className="t-TmLinkButtonInput__select"
                header={t.tm_link_button_header}
                errors={this.props.tmErrors}
                value={this.props.tmValue || _.first(this.props.tmOptions).id}
                options={this.props.tmOptions}
                onChange={this.props.onTmChange}
              />
            )}
            {!this.props.hideFb && (
              <SelectInput
                className="t-FbLinkButtonInput__select"
                header={t.fb_link_button_header}
                errors={this.props.fbErrors}
                value={this.props.fbValue || _.first(this.props.fbOptions).id}
                options={this.props.fbOptions}
                onChange={this.props.onFbChange}
              />
            )}
          </SelectInputWrapper>
        </Row>
      )
    )
  }

  isShown() {
    return !this.props.hideVk || !this.props.hideTm || !this.props.hideFb
  }
}
